import { Link } from 'react-router-dom'
import { ArrowRightIcon } from './Icons'
import '../styles/ProjectPlanCard.css'

function ProjectPlanCard({ plan, project }) {
  const completedTasks = plan.tasks.filter(t => t.status === 'completed').length
  const totalTasks = plan.tasks.length
  const progress = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0

  // Get background image from project's first photo
  const backgroundImage = project?.images?.[0] || null

  return (
    <Link
      to={`/elise/plans/${plan.id}`}
      className="project-plan-card"
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none'
      }}
    >
      <div className="plan-card-overlay">
        <div className="plan-card-header">
          <div className="plan-title-section">
            <h3 className="plan-title">{plan.title}</h3>
            {project && <p className="project-title">{project.title}</p>}
          </div>
          <div className="plan-progress">
            <div className="progress-text">
              {completedTasks}/{totalTasks} tasks
            </div>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </div>

        <div className="plan-card-footer">
          {plan.description && (
            <p className="plan-description">{plan.description}</p>
          )}
          <span className="view-link">
            View Plan <ArrowRightIcon size={16} />
          </span>
        </div>
      </div>
    </Link>
  )
}

export default ProjectPlanCard
